var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tracking-table',{staticClass:"mt-3",attrs:{"data":_vm.data,"tableLoading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }